module.exports = __webpack_public_path__ + "public/images/stand-logo.261ca97dc965ce429a18a0078f11bfe3.webp";